import { round } from 'lodash-es';

import { TripRead } from 'src/common/external/bambi-api/bambiApi';
import { Skeleton } from 'src/common/Skeleton';

interface TripDetailsEstimatedMileageProps {
  isTripDataLoading: boolean;
  tripData?: TripRead;
}

export function TripDetailsEstimatedMileage({
  isTripDataLoading,
  tripData,
}: TripDetailsEstimatedMileageProps) {
  const estimatedMileage = tripData?.estimated_distance_miles;

  if (!estimatedMileage && !isTripDataLoading) return null;

  return (
    <div className="pb-2">
      <h4 className="py-2 text-sm font-bold">Estimated Mileage</h4>
      {isTripDataLoading ? (
        <Skeleton />
      ) : (
        <p className="text-sm font-medium text-gray-500">
          {round(estimatedMileage ?? 0, 2)}
        </p>
      )}
    </div>
  );
}
